import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { TabComponent } from './Tab.component';
import { TabNavigatorComponent } from './TabNavigator.component';

@NgModule({
    imports: [CommonModule, CoreUiModule],
    declarations: [TabNavigatorComponent, TabComponent],
    exports: [TabNavigatorComponent, TabComponent],
    providers: []
})
export class TabsModule {}
